// src/pages/PostageAccountList.js
import React, { useState, useEffect } from 'react';
import { fetchPostageAccounts } from '../services/api';

function PostageAccountList() {
  const [accounts, setAccounts] = useState([]);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchPostageAccounts()
      .then(data => {
        setAccounts(data);
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Failed to fetch accounts:', error);
        setError('Failed to fetch accounts');
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return <div className="container mt-3"><h1>Loading...</h1></div>; // Display loading message
  }

  return (
    <div className="container mt-3">
      <h1>Postage Accounts</h1>
      {error && <div className="alert alert-danger" role="alert">{error}</div>}
      <table className="table">
        <thead>
          <tr>
            <th>Account Number</th>
            <th>Department</th>
            <th>Worktag String</th>
            <th>Owner - NetId</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {accounts.map(account => (
            <tr key={account.id}>
              <td>{account.postageAccountNumber}</td>
              <td>{account.department}</td>
              <td>{account.worktagString}</td>
              <td>{account.owner ? `${account.owner?.firstName} ${account.owner?.lastName} - ${account.owner?.netId}` : 'No owner assigned'}</td>
              <td><a href={`/postage-account/${account.postageAccountNumber}`}>View Details</a></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default PostageAccountList;
